/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PrincipalRolesControllerRemoveMutationResponse, PrincipalRolesControllerRemovePathParams, PrincipalRolesControllerRemoveQueryParams, PrincipalRolesControllerRemove401, PrincipalRolesControllerRemove403, PrincipalRolesControllerRemove404 } from "../../models/principalRolesController/PrincipalRolesControllerRemove";

function getPrincipalRolesControllerRemoveUrl(id: PrincipalRolesControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/principal-roles/${id}` as const }  
  return res
}

/**
 * @description Deletes a principal role assignment. By default, performs a soft delete (marks as deleted but keeps in database for recovery). Use hardDelete=true to permanently remove the assignment from the database. Use revoke=true to run revoke behavior for Organization Administrator roles at ORGANIZATION scope. When revoke=true and eligible, revoke behavior takes precedence over hardDelete.
 * @summary Delete a principal role assignment
 * {@link /api/v1/principal-roles/:id}
 */
export async function principalRolesControllerRemove(id: PrincipalRolesControllerRemovePathParams["id"], params?: PrincipalRolesControllerRemoveQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PrincipalRolesControllerRemoveMutationResponse, ResponseErrorConfig<PrincipalRolesControllerRemove401 | PrincipalRolesControllerRemove403 | PrincipalRolesControllerRemove404>, unknown>({ method : "DELETE", url : getPrincipalRolesControllerRemoveUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}